<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">핏페이관리</span>
            <span class="txt">센터별 핏페이 서비스 신청현황을 관리할수 있습니다.</span>
        </div>
        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="period"
                    @update:set="(val) => (period = val)"
                ></select-form>

                <select-form
                    :select-data="['처리상태', '미승인', '승인', '반려']"
                    :select-value="['', 'P', 'D', 'R']"
                    :selected-value="status"
                    @update:set="(val) => (status = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>

                <div class="com-search-input">
                    <input v-model="searchStr" placeholder="검색어 입력" type="text" v-on:keyup.enter="onEventSearch" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
        </div>
        <div class="com-table-content mt-10">
            <table class="com-table">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="width: 220px" />
                    <col style="width: 140px" />
                    <col style="width: 140px" />
                    <col style="width: 200px" />
                    <col style="width: auto" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button
                                :class="sortType === 'ASC' ? 'asc' : 'desc'"
                                @click="(sortType = sortType === 'ASC' ? 'DESC' : 'ASC'), fetchFitpayList()"
                            >
                                신청일
                            </button>
                        </th>
                        <th>센터명</th>
                        <th>정산 담당자명</th>
                        <th>담당자 연락처</th>
                        <th>담당자 이메일</th>
                        <th>정산 계좌 정보</th>
                        <th colspan="2">처리상태</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(item, index) in fitpayList" :key="`C${index}`">
                        <td>{{ item.cf_cre_dt | timestampFilter }}</td>
                        <td>
                            <span role="button" class="link underline" @click="selectedItem = item">
                                {{ item.center_nm }}
                            </span>
                        </td>
                        <td>{{ item.namee }}</td>
                        <td>{{ item.cf_contact_tel }}</td>
                        <td>{{ item.cf_contact_email }}</td>
                        <td>
                            <span role="button" class="link underline" @click="selectedBankbook = item">
                                ({{ item.cf_bank_name }}) {{ item.cf_bank_number }}
                            </span>
                        </td>
                        <td>
                            <span v-if="item.cf_status === 'P'" class="state-txt-P">미승인</span>
                            <span v-if="item.cf_status === 'D'" class="state-txt-D">승인완료</span>
                            <span
                                role="button"
                                v-if="item.cf_status === 'R'"
                                class="state-txt-R underline"
                                @click="rejectItem = item"
                            >
                                반려
                            </span>
                        </td>
                        <td>
                            <div v-if="item.cf_status == 'P'">
                                <button class="com-btn blue" :disabled="submitting" @click="handleAprove(item)">
                                    승인
                                </button>
                                <button class="com-btn red" :disabled="submitting" @click="handleReject(item)">
                                    반려
                                </button>
                            </div>
                            <div v-else>{{ item.cf_upd_dt | timestampFilter }}</div>
                        </td>
                    </tr>
                    <tr v-if="fitpayList.length == 0">
                        <td colspan="100">
                            <loading-spinner v-if="isLoading"></loading-spinner>
                            <span v-else>등록된 내용이 없습니다.</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    :selected-value="pagingInfo.limit"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
        </div>
        <b-pagination
            class="mt-10"
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event, 'center')"
        ></b-pagination>

        <fitpay-request-list-dlg
            :show="!!selectedItem"
            :close="() => (selectedItem = null)"
            :centerId="selectedItem ? selectedItem.cf_center_id : ''"
            :centerName="selectedItem ? selectedItem.center_nm : ''"
        ></fitpay-request-list-dlg>
        <bankbook-confirm-dlg
            :show="!!selectedBankbook"
            :close="() => (selectedBankbook = null)"
            :imageUrl="selectedBankbook ? selectedBankbook.cf_bank_book_url : ''"
            :downloadName="selectedBankbook ? selectedBankbook.cf_bank_book_name : ''"
        ></bankbook-confirm-dlg>
        <reject-reason-dlg
            :show="!!rejectItem"
            :editable="rejectItem && rejectItem.cf_status === 'P'"
            :content="rejectItem ? rejectItem.cf_reject_reason : ''"
            :close="() => (rejectItem = null)"
            :confirm="reject"
        ></reject-reason-dlg>
    </div>
</template>

<script>
import api from '../../../../assets/js/api';
import moment from 'moment';
import EventBus from '../../../../assets/js/eventBus';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import { pagingInfo } from '@/assets/js/common';
import FitpayRequestListDlg from '@/components/FitpayRequestListDlg';
import BankbookConfirmDlg from '@/components/BankbookConfirmDlg';
import RejectReasonDlg from '@/components/RejectReasonDlg';

export default {
    name: 'businessFitpayList',
    components: { LoadingSpinner, FitpayRequestListDlg, BankbookConfirmDlg, RejectReasonDlg },
    props: {},
    watch: {
        status(newValue) {
            this.status = newValue;
            this.fetchFitpayList(1);
        },
        period(newValue) {
            // 검색 기간 설정 변수
            this.period = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.startDate = this.initStartDate();
                this.endDate = this.initEndDate();
            }
            this.fetchFitpayList(1);
        },
    },
    computed: {
        rows() {
            return this.items.length;
        },
        isCareAdmin() {
            return this.$store.getters['auth/isCareAdmin'];
        },
        isSystemAdmin() {
            return this.$store.getters['auth/isSystemAdmin'];
        },
    },
    data() {
        return {
            isLoading: false,
            submitting: false,
            fitpayList: [],
            pagingInfo: { ...pagingInfo }, // 센터 목록 페이징 정보
            startDate: '2015-01-01',
            endDate: moment().format('YYYY-MM-DD'),
            status: '',
            searchStr: '',
            period: '',
            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            sortType: 'DESC',
            count: 0,
            rejectItem: null,
            selectedItem: null,
            selectedBankbook: null,
        };
    },
    mounted() {
        if (this.isCareAdmin || this.isSystemAdmin) {
            this.fetchFitpayList(1);
        } else {
            alert('권한이 없습니다.');
            this.$router.push('/care/login');
        }
    },
    methods: {
        async fetchFitpayList(pageNum) {
            if (this.isLoading) return;

            this.isLoading = true;

            const res = await api.get(`/admin/api/center/fitpay/list/search`, {
                params: {
                    ...this.pagingInfo,
                    page: pageNum || this.pagingInfo.page,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    status: this.status,
                    searchStr: this.searchStr || '',
                    sortType: this.sortType || 'DESC',
                },
            });

            this.isLoading = false;
            if (res.data) {
                this.fitpayList = res.data.items || [];

                const metaData = res.data.meta;
                this.pagingInfo = {
                    ...this.pagingInfo,
                    page: metaData.currentPage,
                    totalItems: metaData.totalItems, // 총 Item 수
                    itemCount: metaData.itemCount, // 현재 페이지 item 수
                    totalPages: metaData.totalPages, // 총 페이지 수
                };
            }
        },
        // 이벤트 발생시 키워드 길이 체크
        onEventSearch(e) {
            if (this.searchStr.length < 2) {
                return;
            }
            this.fetchFitpayList();
        },

        // 페이지 변경 Handler
        handlerPagenation(event) {
            this.fetchFitpayList(event);
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.fetchFitpayList();
        },

        // 검색 종료일
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            return endDate;
        },
        // 검색 시작일
        initStartDate() {
            // const startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
            // return startDate;
            return '2015-01-01';
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.fetchFitpayList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.fetchFitpayList();
        },

        // 검색 조건 초기화
        resetSearchContent() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.period = '';
            this.status = '';
            // this.searchStr = '';
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            this.fetchFitpayList();
            // EventBus.$emit('event:init', 'init');
        },

        handleReject(item) {
            this.rejectItem = { ...item };
        },
        async reject(content) {
            if (!this.rejectItem || !content || this.submitting) return;

            this.submitting = true;
            const res = await api.post(`/admin/api/center/fitpay/reject/${this.rejectItem.cf_id}`, { content });
            this.submitting = false;

            this.rejectItem = null;
            this.fetchFitpayList();
        },
        async handleAprove(item) {
            if (!confirm('핏페이 사용 신청을 승인하시겠습니까?') || this.submitting) return;

            this.submitting = true;
            const res = await api.post(`/admin/api/center/fitpay/approve/${item.cf_id}`);
            this.submitting = false;

            this.fetchFitpayList();
        },
    },
};
</script>
<style lang="scss">
.state-txt-P {
    color: #00c7e5;
}
.state-txt-R {
    color: #f64444;
}
</style>
